import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { isValidElementType } from 'react-is';
import { filter } from "./fn";

/**
 * Wraps parametrized HOC function allowing to call it both with param, or without it, as follows:
 * - HOC(params)(WrappedComponent)
 * - HOC(WrappedComponents)
 */
export var allowParamOmit = function allowParamOmit(HOC) {
  return function (arg) {
    return isValidElementType(arg) ? HOC()(arg) : HOC(arg);
  };
};

/**
 * Wraps component by passing:
 * `finalProps` that can no longer be changed and
 * `defaultProps` that can be overridden
 */
export var defineProps = function defineProps(finalProps, defaultProps) {
  return function (WrappedComponent) {
    var RedefinedComponent = function RedefinedComponent(props) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, defaultProps, props, finalProps, {
        "data-t-id": "source-utils"
      }));
    };
    if (process.env.NODE_ENV !== 'production') {
      RedefinedComponent.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
      RedefinedComponent.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, filter(WrappedComponent.propTypes, function (_, propName) {
        return !(propName in (finalProps || {}));
      })) : {};
    }
    return RedefinedComponent;
  };
};

/**
 * A shortcut used by factories designed via same interface,
 * passes final prop childComponents
 */
export var defineFactoryComponents = function defineFactoryComponents(childComponents) {
  return defineProps({
    childComponents: childComponents
  });
};
var SecretPrevProps = '__prevRenderProps';

/**
 * Wrapper around getDerivedStateFromProps to only react on props change and ignore setState calls
 */
export var ignoreState = function ignoreState(getDerivedStateFromProps) {
  return function (nextProps, prevState) {
    if (prevState[SecretPrevProps] !== nextProps) {
      return _objectSpread(_objectSpread({}, getDerivedStateFromProps(nextProps, prevState)), {}, _defineProperty({}, SecretPrevProps, nextProps));
    }
    return null;
  };
};